import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Chift\CreateCompanyConnexionController::__invoke
* @see app/Http/Controllers/Chift/CreateCompanyConnexionController.php
* @route '/api/company/{company}/chift/connexion'
*/
const CreateCompanyConnexionController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateCompanyConnexionController.url(args, options),
    method: 'post',
})

CreateCompanyConnexionController.definition = {
    methods: ["post"],
    url: '/api/company/{company}/chift/connexion',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Chift\CreateCompanyConnexionController::__invoke
* @see app/Http/Controllers/Chift/CreateCompanyConnexionController.php
* @route '/api/company/{company}/chift/connexion'
*/
CreateCompanyConnexionController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return CreateCompanyConnexionController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Chift\CreateCompanyConnexionController::__invoke
* @see app/Http/Controllers/Chift/CreateCompanyConnexionController.php
* @route '/api/company/{company}/chift/connexion'
*/
CreateCompanyConnexionController.post = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateCompanyConnexionController.url(args, options),
    method: 'post',
})

export default CreateCompanyConnexionController